export enum LoginTypes {
  Employee = 1,
  Representative = 2,
}
